var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.459,
    height: 22,
    viewBox: "0 0 28.459 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1149.229 -5143.698)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1126.37,5150.13a5.605,5.605,0,0,0-5.6,5.6,5.606,5.606,0,0,0,5.6,5.6,5.606,5.606,0,0,0,5.6-5.6A5.605,5.605,0,0,0-1126.37,5150.13Zm0,10a4.406,4.406,0,0,1-4.4-4.4,4.405,4.405,0,0,1,4.4-4.4,4.405,4.405,0,0,1,4.4,4.4A4.406,4.406,0,0,1-1126.37,5160.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1125.321,5157.571a1.934,1.934,0,0,1-.627.106,1.942,1.942,0,0,1-1.843-1.348h1.2a.6.6,0,0,0,.6-.6.6.6,0,0,0-.6-.6h-1.2a1.959,1.959,0,0,1,2.466-1.243.6.6,0,0,0,.76-.376.6.6,0,0,0-.376-.76,3.152,3.152,0,0,0-1.013-.169,3.15,3.15,0,0,0-3.087,2.548h-.349a.6.6,0,0,0-.6.6.6.6,0,0,0,.6.6h.349a3.151,3.151,0,0,0,3.087,2.548,3.154,3.154,0,0,0,1.014-.169.6.6,0,0,0,.375-.762A.6.6,0,0,0-1125.321,5157.571Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1132.385,5163.636h1.375a.343.343,0,0,0,.343-.344.343.343,0,0,0-.343-.344h-1.375a.344.344,0,0,0-.344.344A.344.344,0,0,0-1132.385,5163.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1132.385,5162.261h1.375a.343.343,0,0,0,.343-.344.343.343,0,0,0-.343-.344h-1.375a.344.344,0,0,0-.344.344A.344.344,0,0,0-1132.385,5162.261Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1142.354,5143.7h-6.188a.687.687,0,0,0-.687.688v4.125a.687.687,0,0,0,.687.687h2.407v.688h-.688a.687.687,0,0,0-.687.687.687.687,0,0,0,.687.688h2.75a.688.688,0,0,0,.688-.688.687.687,0,0,0-.688-.687h-.687v-.688h2.406a.686.686,0,0,0,.687-.687v-4.125A.687.687,0,0,0-1142.354,5143.7Zm-.688,4.125h-4.812v-2.75h4.812Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1145.936,5152.491a.7.7,0,0,0-.2.488.676.676,0,0,0,.2.485.682.682,0,0,0,.485.2.679.679,0,0,0,.485-.2.677.677,0,0,0,.2-.485.694.694,0,0,0-.2-.488A.716.716,0,0,0-1145.936,5152.491Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.688,
    cy: 0.688,
    r: 0.688,
    transform: "translate(-1146.135 5157.792)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.688,
    cy: 0.688,
    r: 0.688,
    transform: "translate(-1146.135 5155.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1145.936,5160.741a.7.7,0,0,0-.2.488.676.676,0,0,0,.2.485.682.682,0,0,0,.485.2.679.679,0,0,0,.485-.2.677.677,0,0,0,.2-.485.694.694,0,0,0-.2-.488A.716.716,0,0,0-1145.936,5160.741Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.688,
    cy: 0.688,
    r: 0.688,
    transform: "translate(-1140.635 5160.542)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.688,
    cy: 0.688,
    r: 0.688,
    transform: "translate(-1143.385 5160.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1137.683,5160.741a.693.693,0,0,0-.2.488.676.676,0,0,0,.2.485.675.675,0,0,0,.485.2.674.674,0,0,0,.485-.2.677.677,0,0,0,.2-.485.694.694,0,0,0-.2-.488A.712.712,0,0,0-1137.683,5160.741Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.688,
    cy: 0.688,
    r: 0.688,
    transform: "translate(-1132.042 5148.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1131.354,5147.136a.677.677,0,0,0,.485-.2.684.684,0,0,0,.2-.485.7.7,0,0,0-.2-.488.713.713,0,0,0-.97,0,.7.7,0,0,0-.2.488.678.678,0,0,0,.2.485A.676.676,0,0,0-1131.354,5147.136Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.688,
    cy: 0.688,
    r: 0.688,
    transform: "translate(-1134.792 5145.761)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.688,
    cy: 0.688,
    r: 0.688,
    transform: "translate(-1137.542 5145.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1140.092,5145.96a.7.7,0,0,0-.2.488.678.678,0,0,0,.2.485.681.681,0,0,0,.485.2.684.684,0,0,0,.485-.2.677.677,0,0,0,.2-.485.692.692,0,0,0-.2-.488A.717.717,0,0,0-1140.092,5145.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1129.979,5161.805v2.518h-3.438V5160.2h1.565a7.135,7.135,0,0,1-.872-1.375h-1.38a.688.688,0,0,0-.688.688v5.5a.687.687,0,0,0,.688.687h4.812a.687.687,0,0,0,.688-.687v-2.573A7.052,7.052,0,0,1-1129.979,5161.805Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCollection);
export default __webpack_public_path__ + "static/media/payment-collection.f05bd7f6bd7752e3d625cd05c2273b63.svg";
export { ForwardRef as ReactComponent };